import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";

const initialState = {
    loading: false,
    error: "",
    InstructorData: [],
    regionData:[],
    studioData:[],
    feedback:[],
    machineData:[],
    instanceData:[],
  };
  export const InstructorList = createAsyncThunk(
    "instructor/api",
    ({ params , endPoints }) => {
      return api_call(
        "get",
        `${CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN + endPoints}`,
        params,
        {},
        {}
      );
    }
  );
  const InstructorListSlice = createSlice({
    name: "instructor",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(InstructorList.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(InstructorList.fulfilled, (state, action) => {
        state.loading = false;
        state.InstructorData = action.payload;
        state.error = "";
      });
      builder.addCase(InstructorList.rejected, (state, action) => {
        state.loading = false;
        state.InstructorData = [];
        state.error = action.error.message;
      });
    },
  });
  export const StudioList = createAsyncThunk(
    "studio/api",
    ({studio_param }) => {
      return api_call(
        "get",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO + API.END_POINTS.STUDIO_LIST
        }`,
        studio_param,
        {},
        {}
      );
    }
  );
  const StudioListSlice = createSlice({
    name: "studio",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(StudioList.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(StudioList.fulfilled, (state, action) => {
        state.loading = false;
        state.studioData = action.payload;
        state.error = "";
      });
      builder.addCase(StudioList.rejected, (state, action) => {
        state.loading = false;
        state.studioData = [];
        state.error = action.error.message;
      });
    },
  });
  export const FeedbackList = createAsyncThunk(
    "feedback/api",
    ({feedback_param }) => {
      return api_call(
        "get",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].FEEDBACK + API.END_POINTS.FEEDBACK_DATA
        }`,
        feedback_param,
        {},
        {}
      );
    }
  );
  const FeedbackListSlice = createSlice({
    name: "feedback",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(FeedbackList.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(FeedbackList.fulfilled, (state, action) => {
        state.loading = false;
        state.feedback = action.payload;
        state.error = "";
      });
      builder.addCase(FeedbackList.rejected, (state, action) => {
        state.loading = false;
        state.feedback  = [];
        state.error = action.error.message;
      });
    },
  });
  export const MachineList = createAsyncThunk(
    "machine/api",
    ({machine_param }) => {
      return api_call(
        "get",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO + API.END_POINTS.AMI_LISTING
        }`,
        machine_param,
        {},
        {}
      );
    }
  );
  const MachineListSlice = createSlice({
    name: "machine",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(MachineList.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(MachineList.fulfilled, (state, action) => {
        state.loading = false;
        state.machineData = action.payload;
        state.error = "";
      });
      builder.addCase(MachineList.rejected, (state, action) => {
        state.loading = false;
        state.machineData = [];
        state.error = action.error.message;
      });
    },  
  });
  export const InstanceList = createAsyncThunk(
    "instance/api",
    ({instance_param }) => {
      return api_call(
        "get",
        `${
          CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO + API.END_POINTS.INSTANCE_LISTING
        }`,
        instance_param,
        {},
        {}
      );
    }
  );
  const InstanceListSlice = createSlice({
    name: "instance",
    initialState,
    extraReducers: (builder) => {
      builder.addCase(InstanceList.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(InstanceList.fulfilled, (state, action) => {
        state.loading = false;
        state.instanceData = action.payload;
        state.error = "";
      });
      builder.addCase(InstanceList.rejected, (state, action) => {
        state.loading = false;
        state.instanceData = [];
        state.error = action.error.message;
      });
    },
  });
  export const CreateSessionData = {
    InstructorList: InstructorListSlice.reducer,
    StudioList: StudioListSlice.reducer,
    FeedbackList: FeedbackListSlice.reducer,
    MachineList: MachineListSlice.reducer,
    InstanceList: InstanceListSlice.reducer
  };